import React from 'react';
import { getIRBApprovalDetails } from 'actions/irb';
import bindLogger from 'helpers/BindLogger';
import { getEncodedQueryParams } from 'helpers';
import { openConfirmation } from 'components/Confirmation/Confirmation';
import IRBApprovalModal from '../IRBApproval/IRBApprovalModal';

const warningDialog = () => {
  openConfirmation({
    header: `Confirmation`,
    message: 'IRB record does not exist for the given Combination of Protocol and Site',
    isClose: true
  });
};

export const openIRBWindow = (
  {
    ctepId, protocolNumber, pktId, id, siteName, length
  },
  hasIrbEditAccess,
  source,
  isChgPi = false
) => {
  // currently the hasIrbEditAccess is not there in API, it will not navigate to the screen
  // removed it after discussing with samarth and leela.
  let params = `instId=${ctepId}&protNum=${protocolNumber}&pktId=${pktId}&isBrowser=${id != null}`;
  if (id != null) {
    params = `${params}&id=${id}`;
  }
  if (siteName) {
    params = `${params}&instName=${siteName}`;
  }
  if (isChgPi) {
    params = `${params}&isChgPi=Y`;
  }

  if (source) {
    params = `${params}&source=${source}`;
  }
  const url = getEncodedQueryParams('/approvals/details', params);
  if (length || hasIrbEditAccess) {
    window.open(url, '_blank');
  } else {
    warningDialog();
  }
};

/**
 *
 * @param {Object} row {siteCtepId, ctepId, protocolNumber, packetId, id, siteName}
 * source => is the context, required for previous and next packet implementation
 * source --> packet_processing | packet_history
 * @param {*} context ref
 */
const onClickIrbButton = (row, context, hasIrbEditAccess, source) => {
  let modal;
  const onIRBRowClick = data => {
    console.log(data);
    openIRBWindow({ ...data, length: 1 }, hasIrbEditAccess, source);
    modal.handleClose();
  };

  const postData = {
    siteCtepId: row.siteCtepId,
    protocolNumber: row.protocolNumber,
    packetId: row.packetId
  };
  bindLogger(
    getIRBApprovalDetails,
    context
  )(postData).subscribe((resp) => {
    const { irbCertificate } = resp.response;
    const inputRow = {
      ctepId: row.siteCtepId,
      protocolNumber: row.protocolNumber,
      pktId: row.packetId
    };
    if (irbCertificate != null && irbCertificate.length > 1) {
      modal = openConfirmation({
        header: 'Select an IRB Approval',
        isClose: true,
        renderComp: () => <IRBApprovalModal data={resp.response.irbCertificate} onIRBRowClick={onIRBRowClick} />
      });
    } else if (irbCertificate != null && irbCertificate.length === 1) {
      inputRow.id = irbCertificate[0].id;
      inputRow.length = irbCertificate.length;
      openIRBWindow(inputRow, hasIrbEditAccess, source);
    } else {
      inputRow.siteName = row.siteName;
      openIRBWindow(inputRow, hasIrbEditAccess, source);
    }
  });
};

const moveToSRScreen = (row) => {
  let srPathParams = `instId=${row.siteCtepId}&protNum=${row.protocolNumber}&packetId=${row.packetId}`;
  if (row.idx !== undefined && row.idx !== null) {
    srPathParams += `&idx=${row.idx}`;
  }
  const url = getEncodedQueryParams('/site-registration/details', srPathParams);
  window.open(url, '_blank');
};

const onClickSRButton = (row) => {
  moveToSRScreen(row);
};

export { onClickIrbButton, onClickSRButton };
